/* eslint-disable security/detect-object-injection */
import React, { useContext } from 'react';
import AnimatedPageFade from '../../components/Animations/AnimatedPageFade';
import AnimatedImage from '../../components/Animations/AnimatedImage';
import AnimatedButton from '../../components/Button';
import ApplicationContext from '../../context/ApplicationContext';
import HTMLViewer from '../../components/HTMLViewer';
import { backNextLanguageContent } from '../../components/Button/backNextLanguageContent';

function ThankYou(props) {
    const { facilityData, selectedLanguage, selectedLanguageName } = useContext(ApplicationContext);
    return (
        <AnimatedPageFade className='flex flex-col justify-between relative h-welcome gradient-bg rounded-[16px] overflow-hidden'>
            <div className='p-[8px]'>
                <p className='text-center font-semibold text-[#64A003] text-[24px] border-b border-[#D7D7D7] py-[5px] lg:text-[26px] xl:text-[32px] 2xl:text-[38px] flex justify-center items-start'>
                    <AnimatedImage url="/images/Smile.svg" alt="smile" className="mr-[5px] -mt-[3px]" />
                    {backNextLanguageContent['thankyou'][selectedLanguage]}
                </p>
                <p className='font-semibold text-base text-primary text-center break-words underline decoration-[#007EB4] mt-[18px]'>Westover Hills Baptist Hospital</p>
                <a href={`tel:(210) 521-2989`} className='font-semibold text-sm text-[#333] text-primary text-center underline decoration-[#007EB4] justify-center break-words mt-[8px] flex items-center'>
                    <img src="/images/Phone-gray.svg" alt="phone" className='mr-[8px]' />
                    (210) 521-2989
                </a>
                <div className='flex justify-center'>
                    <div className='facility-profile mt-[55px] text-sm overflow-x-hidden overflow-y-auto thankyou-height Form-scroll pr-1'>
                        <HTMLViewer htmlContent={facilityData?.thank_you_message[selectedLanguageName]} />
                    </div>
                </div>
            </div>
            {/* <div className='flex mb-[24px] justify-center mx-[16px] w-auto fold-gap'>
                <AnimatedButton disabled={false}
                    handleClick={() => {sessionStorage.clear()}} id="close" className={`font-semibold text-gray w-[200px] h-[40px] pl-[41px] text-[16px] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[18px] justify-center bg-[#F2F2F2]`}>
                    {backNextLanguageContent['close'][selectedLanguage]}
                    <img src="/images/Close-button.svg" alt="next" className='ml-[2.5em] w-[1.7em] h-[1.7em]' />
                </AnimatedButton>
            </div> */}
        </AnimatedPageFade>
    );
}

export default ThankYou;